import { gql } from '@/__generated__/storefront';

export const searchProductsForWishlistQuery = gql(`
  query SearchProductsForWishlist(
    $productQuery: String!
    $productFilters: [ProductFilter!]!
    $patternQuery: String!
    $country: CountryCode!
    $firstProducts: Int!
    $firstPatterns: Int!
  ) @inContext(country: $country) {
    products: search(
      query: $productQuery
      first: $firstProducts
      types: [PRODUCT]
      productFilters: $productFilters
    ) {
      nodes {
        __typename
        ... on Product {
          id
          handle
          title
          availableForSale
          isGiftCard
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          featuredImage {
            url
            altText
            width
            height
          }
          entityIdMetafield: metafield(namespace: "hobbii", key: "entity_id") {
            value
          }
          productGroupIdMetafield: metafield(namespace: "hobbii", key: "product_group_id") {
            value
          }
          metafields(identifiers: [
            {namespace: "hobbii", key: "yarn_composition"}
          ]) {
            key
            value
          }
          variants(first: 100) {
            nodes {
              id
              sku
              title
              availableForSale
              quantityAvailable
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              image {
                url
                altText
              }
            }
          }
        }
      }
    }
    patterns: search(
      query: $patternQuery
      first: $firstPatterns
      types: [PRODUCT]
      productFilters: [
        {
          productMetafield: {
            namespace: "hobbii"
            key: "entity_type"
            value: "pattern"
          }
        }
      ]
    ) {
      nodes {
        __typename
        ... on Product {
          id
          handle
          title
          availableForSale
          isGiftCard
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          compareAtPriceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          featuredImage {
            url
            altText
            width
            height
          }
          entityIdMetafield: metafield(namespace: "hobbii", key: "entity_id") {
            value
          }
          productGroupIdMetafield: metafield(namespace: "hobbii", key: "product_group_id") {
            value
          }
          metafields(identifiers: [
            {namespace: "hobbii", key: "yarn_composition"}
          ]) {
            key
            value
          }
          variants(first: 100) {
            nodes {
              id
              sku
              title
              availableForSale
              quantityAvailable
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
              image {
                url
                altText
              }
            }
          }
        }
      }
    }
  }
`);
